<template>
	<div>
		<div class="empty-img" v-show="classnum">
      <img src="./noclass.png"/>
      <p>无报名课程</p>
    </div >
		<div class="me-lesson">
			<ul class="me-lesson-items" v-dt-infinite-scroll="getData">
				<!--<li class="me-lesson-item">
					<div class="me-lesson-main f-cb">
						<div class="me-lesson-pic f-img-box">
							<img src="../index/collection-pic.png">
							<div class="me-lesson-pic-text">6天后到期</div>
						</div>
						<div class="me-lesson-content">
							<div class="me-lesson-title o1">Axure入门</div>
							<div class="me-lesson-place">天津文化馆</div>
							<div class="me-lesson-info f-cb">
								<div class="me-lesson-last">上次学习 2018.8.10</div>
								<div class="me-lesson-rate">已学 56%</div>
							</div>
						</div>
					</div>
					<div class="me-lesson-ops">
						<div class="me-lesson-comment">评价</div>
						<div class="me-lesson-cancel">取消报名</div>
					</div>
				</li>-->
				<li class="me-lesson-item" v-for="(item,index) in data">
					<div class="me-lesson-main f-cb" @click="$router.push('/lesson-detail/'+item.id)">
						<div class="me-lesson-pic f-img-box">
							<img :src="item.cover_img">
							<div class="me-lesson-pic-text">{{item.end_time!=0 ? tools.timestampToText(item.end_time)+"后到期" : "无期限"}}</div>
						</div>
						<div class="me-lesson-content">
							<div class="me-lesson-title o1">{{item.course_title}}</div>
							<div class="me-lesson-place">{{item.teacherNickName}}</div>
							<div class="me-lesson-info f-cb">
								<div class="me-lesson-last">上次学习 {{tools.timestampConversion(item.last_stu_time)}}</div>
								<div class="me-lesson-rate">已学 {{item.schedule}}</div>
							</div>
						</div>
					</div>
					<div class="me-lesson-ops">
						<div class="me-lesson-certificate me-lesson-certificate-see" v-if="item.wx_pdf_status == 1" @click="pdf_preview(item.pdf_image)">查看证书</div>
						<div class="me-lesson-certificate me-lesson-certificate-disable" v-else-if="item.wx_pdf_status == 2">证书生成中</div>
						<div class="me-lesson-certificate" v-else-if="item.wx_pdf_status == 3" @click="getPdfObjectId(index,item.id)">下载证书</div>
						<div class="me-lesson-comment" @click="$router.push('/comment/'+item.id)">评价</div>
						<div class="me-lesson-cancel" @click="cancelEnroll(index)">取消报名</div>
					</div>
				</li>
			</ul>
		</div>
		<div class="fx_pop" v-if="popupVisible" @click="popupVisible = false"
			 style="position: fixed; top: 0; left: 0; width: 100%; height: 100%; background: rgba(5,0,1,.85);">
			<img style="width: 100%; box-sizing: unset;"
				 src="../../../static/img/cover.png">
		</div>
		<div v-if="isshadow" @click="hideshadow" class="shadow" style="position:fixed;top:0;left:0;width:100%;height:100vh;background: rgba(0, 0, 0, 0.6);z-index:9;">
			<img src="./light.png" alt="" style="width:5rem;position:absolute;top:6.43rem;left:50%;transform:translateX(-50%);">
			<img src="./printer.gif" alt="" style="width:4.6rem;position:absolute;top:6.2rem;left:50%;transform:translateX(-50%);">
			<div style="width:6.35rem;position:absolute;top:11.44rem;left:50%;transform:translateX(-50%);color: #FFFFFF;font-size: 0.45rem;line-height: 0.68rem;text-align:center;">证书生成中，可关闭当前页面， 稍后查看结果</div>
		</div>
	</div>
</template>

<script>
	function is_weixn(){
		var ua = navigator.userAgent.toLowerCase();
		if(ua.match(/MicroMessenger/i)=="micromessenger") {
			return true;
		} else {
			return false;
		}
	}

	export default{
		data(){
			return{
				data:[],
				popupVisible:false,
        classnum:false,
		isshadow:false
			}
		},
		methods:{
			getData(page){
				return new Promise((resolve,reject)=>{
					this.$api.get("",{
						api:"/v1/my/myCourse",
						user_type:this.tools.getStorage("user_type"),
						len:5,
						page
					},res => {
						var data=res.data;
						this.data=this.data.concat(data);
						if(data.length<5){
							reject();
						}
						else{
							resolve();
						}
            if (this.data.length == 0) {
              this.classnum = true;
            }
					})
				})
			},
			cancelEnroll(index){
				console.log(this)
				this.$messagebox.confirm("确定要取消报名吗？").then(()=>{
					this.$api.get("",{
						api:"/v1/baoming/cancel",
						course_id:this.data[index].id,
						user_type:this.tools.getStorage("user_type")
					},res=>{
						this.$toast("取消成功！")
						this.data.splice(index,1);
					})
				})
			},
			//pdf下载证书
            getPdfObjectId(index, course_id) {
				this.isshadow = true;
				    this.$api.get('',
				              {
								api: '/v1/certificatenew/certificateAudit',
								user_type: this.tools.getStorage("user_type"),
								course_id: course_id,
								pdf_type: 2,
							  },
							  res=>{
								if(res.status == 1){
								    this.updateMyCoursePdf(index, res.objectId, course_id);
								}else{
									this.$toast(res.msg);
								}
							  }
							)
            },
			//更新我的课程pdf
			updateMyCoursePdf(index, object_id, course_id){
                    this.$api.get('',
				              {
								api: '/v1/certificatenew/updatePdfObjectId',
								user_type: this.tools.getStorage("user_type"),
								course_id: course_id,
								object_id: object_id
							  },
							  res=>{
								  if(res.status == 1){
								   	this.data[index].wx_pdf_status = 2;
								}else{
									this.$toast(res.msg);
								}
							  }
							)
			},
			//pdf图片预览
			pdf_preview(url){
                 location.href= url;
			},
			// 隐藏提示
			hideshadow(){
				this.isshadow = false;
				location.reload();
			}

		}
	}
</script>

<style>
	.me-lesson-item{
		padding:0.533rem 0 0 0;
	}
	.me-lesson-main{
		padding:0.266rem 0.4rem;
		background: #eee;
	}
	.me-lesson-pic{
		position: relative;
		float:left;
		width:2.88rem;
		height:2.106rem;
		border-radius: 0.133rem;
	}
	.me-lesson-pic-text{
		position: absolute;
		bottom:0;
		left:0;
		height:0.666rem;
		line-height:0.666rem;
		text-align: center;
		font-size: 0.346rem;
		color:#fff;
		width:100%;
		background:rgba(0,0,0,0.5);
	}
	.me-lesson-content{
		float:right;
		width:6rem;
	}
	.me-lesson-title{
		margin-top:0.133rem;
		color:#333;
		font-size: 0.426rem;
	}
	.me-lesson-place{
		margin-top:0.2rem;
		font-size: 0.346rem;
		color:#999;
	}
	.me-lesson-info{
		margin-top:0.466rem;
		font-size: 0.346rem;
		line-height:0.346rem;
		color:#999;
	}
	.me-lesson-last{
		float:left;
	}
	.me-lesson-rate{
		float: right;
	}
	.me-lesson-ops{
		margin:0.4rem 0.4rem 0 0.4rem;
		padding-bottom: 0.4rem;
		height:0.693rem;
		border-bottom: 1px solid #e6e6e6;
	}
	.me-lesson-comment{
		float:right;
		box-sizing: border-box;
		width:1.28rem!important;
		height: 0.75rem !important;;
		margin-right: 0.4rem;
		border:0px solid #999999!important;
		text-align: center;
		line-height:0.75rem !important;;
		color:#FFFFFF!important;
		border-radius: 0.11rem;
		background: #0368C0;
		color: #FFFFFF;
	}
	.me-lesson-certificate{
		float:right;
		box-sizing: border-box;
		width:1.92rem;
		height:0.75rem;
		/* border: 1px solid white; */
		text-align: center;
		line-height: .75rem;
		color: white;
		background: #0368C0;
		border-radius: 0.11rem;

	}
	.me-lesson-cancel{
		float:right;
		margin-right: 0.586rem;
		line-height:0.693rem;
		color:#ccc;
	}
	.me-lesson-certificate-disable{
		color:#999999;
		background: #E5E6EB;
	}
	.me-lesson-certificate-see{
		background: #EA7344;
	}
</style>



// WEBPACK FOOTER //
// src/components/me-lesson/me-lesson.vue